const MS_TEAM_CONSTANTS = {
    'local': {
        'MICROSOFT_APP_ID': '2b3396bc-9d37-43f7-8c3c-a34c499de20d',
    },
    'test': {
        'MICROSOFT_APP_ID': '2b3396bc-9d37-43f7-8c3c-a34c499de20d',
    },
    'qa': {
        'MICROSOFT_APP_ID': '2b3396bc-9d37-43f7-8c3c-a34c499de20d',
    },
    'pprd': {
        'MICROSOFT_APP_ID': '2b3396bc-9d37-43f7-8c3c-a34c499de20d',
    },
    'prod': {
        'MICROSOFT_APP_ID': '2b3396bc-9d37-43f7-8c3c-a34c499de20d',
    }
};
let env = window.location.hostname
    .toLowerCase()
    .split( '.' )
    .find( function ( chunk ) {
        return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
    } );
if ( window.location.origin.indexOf( '://localhost' ) >= 0 ) {
    env = 'local';
}

module.exports = {
    get MICROSOFT_APP_ID() {
        return getEnvVar( 'MICROSOFT_APP_ID' );
    }
};

const getEnvVar = ( name ) => {
    return    MS_TEAM_CONSTANTS[ env ? env : 'prod' ][ name ];
};

